import React from 'react'

/**
 */
export const Progress = () => <>認証中...</>
